@if (detail(); as dto) {
<div class="detail-page">

  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <button nbButton ghost status="basic" (click)="goBack()" class="back-btn">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <div class="header-title">
        <h1>{{ dto.maintenanceTimer.buildingEquipment.equipment.name }}</h1>
        <span class="header-sub">{{ dto.maintenanceTimer.buildingEquipment.sectionText }}</span>
      </div>
    </div>
    <div class="header-actions">
      <button nbButton ghost status="basic" size="small" (click)="downloadPdf()" nbTooltip="Wartungsprotokoll herunterladen">
        <nb-icon pack="eva" icon="download-outline"></nb-icon>
      </button>
      @if (dto.protocol) {
        <button nbButton ghost status="basic" size="small" (click)="downloadProtocolPdf(dto.protocol.id)" nbTooltip="Protokoll PDF herunterladen">
          <nb-icon pack="eva" icon="file-text-outline"></nb-icon>
        </button>
      }
    </div>
  </div>

  <!-- Key metrics -->
  <div class="metrics-row">
    <div class="metric-card" [class.metric-card--ok]="dto.finishedInTime" [class.metric-card--late]="!dto.finishedInTime">
      <nb-icon pack="eva" [icon]="dto.finishedInTime ? 'checkmark-circle-2-outline' : 'alert-circle-outline'"></nb-icon>
      <span class="metric-value">{{ dto.finishedInTime ? 'Rechtzeitig' : 'Verspätet' }}</span>
      <span class="metric-label">Status</span>
    </div>
    <div class="metric-card">
      <nb-icon pack="eva" icon="calendar-outline"></nb-icon>
      <span class="metric-value">{{ dto.maintenanceDate | date:'dd.MM.yyyy' }}</span>
      <span class="metric-label">Wartungsdatum</span>
    </div>
    @if (dto.overdueDays > 0) {
      <div class="metric-card metric-card--late">
        <nb-icon pack="eva" icon="clock-outline"></nb-icon>
        <span class="metric-value">{{ dto.overdueDays }} {{ dto.overdueDays === 1 ? 'Tag' : 'Tage' }}</span>
        <span class="metric-label">Überfällig</span>
      </div>
    }
    <div class="metric-card">
      <nb-icon pack="eva" icon="person-outline"></nb-icon>
      <span class="metric-value">{{ dto.finisherName }}</span>
      <span class="metric-label">Durchgeführt von</span>
    </div>
    <div class="metric-card">
      <nb-icon pack="eva" icon="briefcase-outline"></nb-icon>
      <span class="metric-value">{{ dto.maintenanceByUserTenantName.name }}</span>
      <span class="metric-label">Unternehmen</span>
    </div>
  </div>

  <div class="content-grid">

    <!-- Left column -->
    <div class="left-col">

      <!-- Timing -->
      <nb-card>
        <nb-card-header>
          <nb-icon pack="eva" icon="calendar-outline"></nb-icon>
          Terminierung
        </nb-card-header>
        <nb-card-body>
          <div class="timeline">
            <div class="timeline-item">
              <div class="timeline-dot timeline-dot--neutral"></div>
              <div class="timeline-content">
                <span class="tl-label">Frühester Termin</span>
                <span class="tl-value">{{ dto.earlyToleranceDay | date:'dd.MM.yyyy' }}</span>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot timeline-dot--primary"></div>
              <div class="timeline-content">
                <span class="tl-label">Geplanter Termin</span>
                <span class="tl-value">{{ dto.maintenanceScheduledDate | date:'dd.MM.yyyy' }}</span>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot" [class.timeline-dot--ok]="dto.finishedInTime" [class.timeline-dot--late]="!dto.finishedInTime"></div>
              <div class="timeline-content">
                <span class="tl-label">Tatsächlicher Termin</span>
                <span class="tl-value">{{ dto.maintenanceDate | date:'dd.MM.yyyy' }}</span>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot timeline-dot--neutral"></div>
              <div class="timeline-content">
                <span class="tl-label">Spätester Termin</span>
                <span class="tl-value">{{ dto.lateToleranceDay | date:'dd.MM.yyyy' }}</span>
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>

      <!-- TGA info -->
      <nb-card>
        <nb-card-header>
          <nb-icon pack="eva" icon="settings-2-outline"></nb-icon>
          TGA / Wartungstimer
        </nb-card-header>
        <nb-card-body>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">TGA</span>
              <span class="info-value">
                {{ dto.maintenanceTimer.buildingEquipment.quantity }} ×
                {{ dto.maintenanceTimer.buildingEquipment.equipment.name }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Typ</span>
              <span class="info-value">{{ dto.maintenanceTimer.type | maintenanceTimerType }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Startdatum</span>
              <span class="info-value">{{ dto.maintenanceTimer.startDate | date:'dd.MM.yyyy' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Wartungsanzahl</span>
              <span class="info-value">{{ dto.maintenanceTimer.iterations }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Bilder Pflicht</span>
              <span class="info-value">{{ dto.imagesMandatory ? 'Ja' : 'Nein' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Zuletzt geändert von</span>
              <span class="info-value">{{ dto.maintenanceTimer.lastModifiedBy?.fullName ?? dto.maintenanceTimer.lastModifiedByName }}</span>
            </div>
          </div>
        </nb-card-body>
      </nb-card>

    </div>

    <!-- Right column -->
    <div class="right-col">

      <!-- Protocol -->
      @if (dto.protocol) {
        <nb-card class="protocol-card">
          <nb-card-header>
            <nb-icon pack="eva" icon="file-text-outline"></nb-icon>
            Protokoll
            <span class="proto-status-pill"
                  [class.proto-status-pill--published]="dto.protocol.status === 'PUBLISHED'">
              {{ dto.protocol.status === 'PUBLISHED' ? 'Veröffentlicht' : 'Entwurf' }}
            </span>
          </nb-card-header>
          <nb-card-body>
            <div class="proto-type-row">
              <span class="protocol-type-badge"
                    [style.border-color]="dto.protocol.protocolType.color"
                    [style.color]="dto.protocol.protocolType.color"
                    [style.background]="dto.protocol.protocolType.color + '18'">
                {{ dto.protocol.protocolType.shortcut }}
              </span>
              <span class="proto-type-name">{{ dto.protocol.protocolType.name }}</span>
            </div>
            <div class="proto-meta">
              <div class="proto-meta-item">
                <nb-icon pack="eva" icon="calendar-outline"></nb-icon>
                <span>{{ dto.protocol.created | date:'dd.MM.yyyy HH:mm' }}</span>
              </div>
            </div>
            <div class="protocol-actions">
              <a [routerLink]="['/protocols', dto.protocol.id]" nbButton status="primary" size="small">
                <nb-icon pack="eva" icon="external-link-outline"></nb-icon>
                Öffnen
              </a>
              <button nbButton status="basic" size="small" (click)="downloadProtocolPdf(dto.protocol.id)">
                <nb-icon pack="eva" icon="download-outline"></nb-icon>
                PDF
              </button>
            </div>
          </nb-card-body>
        </nb-card>
      }

      <!-- Comment -->
      <nb-card>
        <nb-card-header>
          <nb-icon pack="eva" icon="message-circle-outline"></nb-icon>
          Kommentar
        </nb-card-header>
        <nb-card-body>
          <p class="comment-text">{{ dto.comment || 'Kein Kommentar vorhanden' }}</p>
        </nb-card-body>
      </nb-card>

      <!-- Photos -->
      <nb-card>
        <nb-card-header>
          <nb-icon pack="eva" icon="image-outline"></nb-icon>
          Bilder
          <span class="count-badge">{{ dto.attachments.length }}</span>
        </nb-card-header>
        <nb-card-body>
          @if (dto.attachments.length > 0) {
            <div class="attachments-grid">
              @for (attachment of dto.attachments; track $index) {
                <wr-attachment-preview
                  [attachment]="attachment"
                  [isDisabled]="true"
                  [selected]="false">
                </wr-attachment-preview>
              }
            </div>
          } @else {
            <p class="empty-hint">Keine Bilder vorhanden</p>
          }
        </nb-card-body>
      </nb-card>

    </div>
  </div>

</div>
} @else {
  <div class="loading-state">
    <nb-spinner></nb-spinner>
  </div>
}
